module.exports = __webpack_public_path__ + "img/kotlin.f8125801.svg";